import { action } from 'easy-peasy';
import { IActionFinishCrisisVisit } from '../types';
import { matchesAllocation, recalculateCrisisStatus } from './helpers';

const finishCrisisVisit: IActionFinishCrisisVisit = action(
  (state, { userId, clientId, crisisCallId, isCanceled }) => {
    if (isCanceled && !userId) {
      return;
    }

    if (!crisisCallId && (!userId || !clientId)) {
      return;
    }

    const teamMembers =
      isCanceled || !crisisCallId
        ? state.crisisCallTeamMembers.filter(member => member.id === userId)
        : state.crisisCallTeamMembers;

    teamMembers.forEach(teamMember => {
      let wasUpdated = false;

      if (isCanceled) {
        teamMember.allocatedClients.forEach(allocation => {
          if (matchesAllocation(allocation, clientId, crisisCallId)) {
            allocation.visitStartTime = '';
            wasUpdated = true;
          }
        });
      } else {
        const nextAllocatedClients = teamMember.allocatedClients.filter(allocation => {
          const shouldRemove = matchesAllocation(allocation, clientId, crisisCallId);

          if (shouldRemove) {
            wasUpdated = true;
          }

          return !shouldRemove;
        });

        teamMember.allocatedClients = nextAllocatedClients;
      }

      if (wasUpdated) {
        recalculateCrisisStatus(teamMember);
      }
    });
  },
);

export default finishCrisisVisit;
